import {defineSlotRecipe} from '@chakra-ui/react3'

export default defineSlotRecipe({
    className: 'leap-recommended-products',
    slots: ['root', 'label', 'slider', 'tile'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'spacing-40', s: 'spacing-80'}
        },
        label: {
            color: 'text.primary',
            textStyle: 'display.small'
        }
    }
})
